module.exports = __webpack_public_path__ + "img/banner10.124abe7e.jpg";